/*
 *  Bootstrap Nice Select Estonian (Estonia) Translation
 *  Author: Kevin Gostomski <kevingostomski2001@gmail.com> 
*/

const localisation = {
    locales: []
}

localisation.locales['et-EE'] = localisation.locales['et'] = {
    formatSearch() {
        return "Otsimine...";
    },
    formatHelpForTagging() {
        return "Enda siltide loomiseks fokusseerige sisestusväli ja vajutage selle loendisse lisamiseks sisestusklahvi või ',' või tühikuklahvi";
    }
}

export default localisation;